import React, { useEffect } from "react";
import { mockData } from "../mock";

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { title, image, paragraphs } = mockData.about;

  return (
    <div className="pt-20">
      <section className="max-w-6xl mx-auto px-6 py-16">
        {/* Header */}
        <div className="text-center mb-16">
          <h1
            className="text-6xl md:text-7xl font-light tracking-wide text-[#3A3A3A] mb-8"
            style={{
              fontFamily: "'Cormorant Garamond', serif",
              animation: "fadeInUp 0.8s ease-out",
            }}
          >
            {title}
          </h1>

          {/* Golden Leaf Divider */}
          <div className="flex justify-center">
            <svg
              width="80"
              height="80"
              viewBox="0 0 80 80"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M40 40C35 30 30 20 28 15C26 10 30 5 35 8C40 11 45 21 50 31"
                stroke="#D4AF37"
                strokeWidth="2"
                fill="none"
              />
              <path
                d="M40 40C45 30 50 20 52 15C54 10 50 5 45 8C40 11 35 21 30 31"
                stroke="#D4AF37"
                strokeWidth="2"
                fill="none"
              />
              <circle cx="40" cy="40" r="3" fill="#D4AF37" />
            </svg>
          </div>
        </div>

        {/* Image */}
        <div
          className="max-w-2xl mx-auto mb-16"
          style={{
            animation: "fadeInUp 0.8s ease-out 0.2s both",
          }}
        >
          <div className="relative group">
            <div className="absolute -inset-4 bg-[#E8D5B5] opacity-50 rounded-lg transform rotate-1 transition-transform duration-300 group-hover:rotate-2"></div>
            <div className="relative bg-white p-6 shadow-xl rounded-lg overflow-hidden">
              <img
                src={image}
                alt="Valerie Bastet"
                className="w-full h-auto object-cover rounded"
                loading="eager"
              />
            </div>
          </div>
        </div>

        {/* Biography Text */}
        <div
          className="max-w-4xl mx-auto space-y-8"
          style={{
            animation: "fadeInUp 0.8s ease-out 0.4s both",
          }}
        >
          {paragraphs.map((paragraph, index) => (
            <p
              key={index}
              className="text-base leading-relaxed text-[#5A5A5A] text-justify"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              {paragraph}
            </p>
          ))}
        </div>

        {/* Bottom Decorative Element */}
        <div className="flex justify-center mt-20">
          <svg
            width="100"
            height="60"
            viewBox="0 0 100 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M30 30C25 25 20 20 20 15C20 10 25 5 30 10C35 15 40 20 45 25"
              stroke="#C9B89A"
              strokeWidth="1.5"
              fill="none"
            />
            <path
              d="M50 25C55 20 60 15 65 10C70 5 75 10 75 15C75 20 70 25 65 30"
              stroke="#C9B89A"
              strokeWidth="1.5"
              fill="none"
            />
            <path
              d="M45 25C45 30 47 35 50 40C53 35 55 30 55 25"
              stroke="#C9B89A"
              strokeWidth="1.5"
              fill="none"
            />
          </svg>
        </div>
      </section>

      <style>{`
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
};

export default About;